.ux-iws-status-label {
    display: inline-flex;
    align-items: center;

    .ux-iws-status-label__icon {
        font-size: 11px;
        margin-right: 10px;
    }
}
